import { render, staticRenderFns } from "./UserSecurity.vue?vue&type=template&id=93237278&"
import script from "./UserSecurity.vue?vue&type=script&lang=js&"
export * from "./UserSecurity.vue?vue&type=script&lang=js&"
import style0 from "./UserSecurity.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports